import { Button, Clickable, H1, Modal, P, SpacerWrapper, Strong } from '@ahmdigital/ui';
import moment from 'moment';
import styled from 'styled-components';

import config from '../../config';
import constants from '../../ahm-constants';

type PremiumReviewModalProps = {
  isOpen?: boolean;
  toggleModal: () => void;
};

const FUTURE_EFFECTIVE_DATE = moment(config.get('features:premiumChange:futureEffectiveDate')).format('D MMMM YYYY');

const MemberCallout = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 2rem;
  padding: 1.25rem;
`;

const StyledClickable = styled(Clickable)`
  flex-grow: 2;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
`;

const StyleP = styled(P)`
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin: 0;
  }
`;

const StyledModal = styled(Modal)`
  height: auto;
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    margin: 20px auto;
    width: 748px;
  }
`;

const PremiumReviewModalContent = styled.div`
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    padding: 0.5rem 4rem 1.5rem;
  }
`;

const PremiumReviewModal = ({ isOpen = false, toggleModal }: PremiumReviewModalProps) => (
  <StyledModal ariaLabelledBy="premium-review-modal" isOpen={isOpen} toggleModal={toggleModal}>
    <PremiumReviewModalContent>
      <H1 looksLike="h3">Premium Review</H1>
      <div>
        <SpacerWrapper variant="marginBottomSpacer10">
          <P>
            Premium changes will take effect from {FUTURE_EFFECTIVE_DATE}. We want to make sure you’re on a cover that
            suits both your health and budget needs, if you have any questions let’s chat.
          </P>
        </SpacerWrapper>
        <StyledClickable to={constants.URLS.SALES.PREMIUM_CHANGE}>Learn more about premium changes</StyledClickable>
        <MemberCallout>
          <StyleP>
            <Strong>Already a member?</Strong> Log in to view your new premium.
          </StyleP>
          <Button
            analytics={{ label: 'Premium Change Modal - Already a member Link' }}
            to={constants.URLS.MEMBERS.HOME}
            variant={['white', 'large']}
          >
            Log in
          </Button>
        </MemberCallout>
      </div>
    </PremiumReviewModalContent>
  </StyledModal>
);

export default PremiumReviewModal;
